export const transactionsResource = {
  name: 'Transactions',
  fields: {
    id: 'Transaction ID',
    sessionId: 'Session ID',
    userId: 'User',
    chargerId: 'Charger',
    stationId: 'Station ID',
    connectorId: 'Connector',
    startTime: 'Start Time',
    endTime: 'End Time',
    duration: 'Duration',
    energyDelivered: 'Energy (kWh)',
    meterStart: 'Meter Start',
    meterStop: 'Meter Stop',
    amount: 'Amount',
    currency: 'Currency',
    paymentStatus: 'Payment Status',
    paymentMethod: 'Payment Method',
    status: 'Status',
    stopReason: 'Stop Reason',
    createdAt: 'Created At',
  },
  list: {
    subtitle: 'View charging transactions',
  },
  show: {
    subtitle: 'Transaction details',
  },
  statuses: {
    active: 'Active',
    completed: 'Completed',
    failed: 'Failed',
    cancelled: 'Cancelled',
  },
  paymentStatuses: {
    pending: 'Pending',
    paid: 'Paid',
    failed: 'Failed',
    refunded: 'Refunded',
  },
};

export const transactions = {
  transactions: transactionsResource,
};